module.exports = __webpack_public_path__ + "img/cepsa-full.ea77d9a0.png";